export const BuildingConstants = {
  SetBuildingsList: 'BUILDING_CONSTANTS.SET_BUILDINGS_LIST',
  SetBuildingStatusList: 'BUILDING_CONSTANTS.SET_BUILDING_STATUS_LIST',
  SetSelectedBuilding: 'BUILDING_CONSTANTS.SET_SELECTED_BUILDING',
  SetNavigationParams: 'BUILDING_CONSTANTS.SET_NAVIGATION_PARAMS',
  SetSelectedBuildingError: 'BUILDING_CONSTANTS.SET_SELECTED_BUILDING_ERROR',
  ClearSelectedBuildingError: 'BUILDING_CONSTANTS.CLEAR_SELECTED_BUILDING_ERROR',
};

// ACTION types
interface SetBuildingsAction {
  type: typeof BuildingConstants.SetBuildingsList;
  payload: SelectedBuilding[];
}

interface SetSelectedBuildingAction {
  type: typeof BuildingConstants.SetSelectedBuilding;
  payload: SelectedBuilding;
}

interface SetNavigationParamsAction {
  type: typeof BuildingConstants.SetNavigationParams;
  payload: NavigationParamsType;
}

export type BuildingActionTypes = SetBuildingsAction | SetSelectedBuildingAction | SetNavigationParamsAction;

// STATE slices
export interface BuildingsListBuilding {
  identifier: string;
  name: string;
  api_location: string;
}

export interface BuildingStatusBuilding {
  name: string;
  building_offline: boolean;
  building_offline_since: string | null;
}

export interface SelectedBuilding {
  identifier: string;
  name: string;
  api_location: string;
  savings_start_datetime: string | null;
  installation_start_date: string | null;
  navigation: CategoryType[];
}

export interface CategoryType {
  api_location: string;
  url: string;
  name: string;
  image: string;
  sub_categories: SubCategoryType[];
  id: string;
}

export interface SubCategoryType {
  api_location: string;
  data_api_location: string;
  id: string;
  url: string;
  name: string;
}

export interface NavigationParamsType {
  selectedCategory: CategoryType;
  selectedSubCategory: SubCategoryType;
}

export interface BuildingReducer {
  navigationParams: NavigationParamsType;
  selectedBuilding: SelectedBuilding;
  buildingsList: BuildingsListBuilding[];
  buildingStatusList: BuildingStatusBuilding[];
  error?: string;
}
